import { render, staticRenderFns } from "./sysintroduction.vue?vue&type=template&id=9c609730&scoped=true"
import script from "./sysintroduction.vue?vue&type=script&lang=js"
export * from "./sysintroduction.vue?vue&type=script&lang=js"
import style0 from "./sysintroduction.vue?vue&type=style&index=0&id=9c609730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c609730",
  null
  
)

export default component.exports